import {
  Button,
  Card,
  CircularProgress,
  TextField,
  Typography,
  InputLabel,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import React, { useEffect, useState } from "react";
import Style from "../../styles/login.module.scss";
import { Link, useNavigate } from "react-router-dom";
import SnackUI from "../../common/SnackUI";
import { useDispatch, useSelector } from "react-redux";
import { registerUserAction } from "../../redux/toolkit/auth/registerUser";
import Visibility from "../../assets/img/eye-closed.png";
import VisibilityOff from "../../assets/img/eye.png";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";

import "../../styles/newRegister.css";
import dashboardImg from "../../assets/img/Dashboard.png";
import Welcome from "../../assets/img/welcome.png";
import Popup from "./Popup";
import RealLogo from "../../assets/newIcons/RealLogo";
import { set } from "react-hook-form";

const NewRegister = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [c_password, setCPassword] = useState("");
  const [company, setCompany] = useState("");
  const [snack, setSnack] = useState(false);
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [popup, setPopup] = useState(false);
  const [validPassword, setValidPassword] = useState(true);
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [disabledButton , setDisabledButton] = useState(false);

  const registerSelector = useSelector((state) => state.registerUser);
  const { message, status, loading } = registerSelector;
  const provider = new GoogleAuthProvider();

  function validatePassword(password) {
    const regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
    return regex.test(password);
  }

  const handleRegister = async (e) => {
    setDisabledButton(true)
    e.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const checkEmail = emailRegex.test(email);
    if (!checkEmail) {
      return alert("Please Enter Valid Email");
    }
    if (!validPassword) {
      return;
    }


    const registerData = await dispatch(
      registerUserAction({ name, email, company, password, c_password })
    );

    if (registerData?.payload?.status == 404) {
    }
    if (registerData?.payload?.status == 200) {
      setPopup(true);

    }
      setDisabledButton(false)
    setSnack(true);
  };

  const showPassword = () => {
    setShow(!show);
  };
  const showPassword2 = () => {
    setShow2(!show2);
  };

  useEffect(() => {
    if (password) {
      const isValid = validatePassword(password);
      if (!isValid) {
        setValidPassword(false);
      } else {
        setValidPassword(true);
      }
    }
  }, [password]);

  return (
    <>
      <div className="container">
        <div className="header">
          <div className="left-header">
            <RealLogo />
          </div>
          <div className="right-header">
            <p>
              Already a user ?
              <button onClick={() => navigate("/login")}>Login</button>
            </p>
          </div>
        </div>

        <div className="form-image-container">
          <div className="form-container">
            <div className="form-header">
              <p className="p1">welcome</p>
              <p className="p3">Create New Account</p>
              {/* <p className="p2">Lorem ipsum dolor sit amet, consectetur adip</p> */}
            </div>

            <div className="form">
              <div className="form-fields">
                <form onSubmit={handleRegister} className="spacey4">
                  <div className="field-wrap">
                    <label htmlFor="name">Name</label>
                    <input
                      type="text"
                      name="name"
                      value={name}
                      placeholder="Enter your full name"
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                  </div>

                  <div className="field-wrap">
                    <label htmlFor="company">Company</label>
                    <input
                      type="text"
                      name="company"
                      value={company}
                      placeholder="Enter your company name"
                      onChange={(e) => setCompany(e.target.value)}
                      required
                    />
                  </div>

                  <div className="field-wrap">
                    <label htmlFor="email">Email</label>
                    <input
                      type="email"
                      name="email"
                      placeholder="Enter your work email address"
                      value={email}
                      /*onClick={handleLogin}*/
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>

                  <div className="field-wrap">
                    <label htmlFor="password">PassWord</label>

                    <div
                      style={{
                        width: "100%",
                        position: "relative",
                        display: "inline-block",
                      }}
                    >
                      <input
                        style={{ width: "100%" }}
                        type={show ? "text" : "password"}
                        name="password"
                        placeholder="Enter your Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />

                      <span
                        style={{
                          position: "absolute",
                          top: "6px",
                          right: "10px",
                          cursor: "pointer",
                        }}
                        onClick={showPassword}
                      >
                        {show ? (
                          <img src={VisibilityOff} width="23px" />
                        ) : (
                          <img src={Visibility} width="23px" />
                        )}
                      </span>
                    </div>
                    {!validPassword && (
                      <p style={{ color: "red", fontSize: 12 }}>
                        Password must be at least 8 characters long and contain
                        at least one uppercase letter, one lowercase letter, and
                        one number
                      </p>
                    )}
                  </div>

                  <div className="field-wrap">
                    <label htmlFor="confirmPassword">Confirm Password</label>
                    <div
                      style={{
                        width: "100%",
                        position: "relative",
                        display: "inline-block",
                      }}
                    >
                      <input
                        style={{ width: "100%" }}
                        type={show2 ? "text" : "password"}
                        name="confirmPassword"
                        placeholder="Confirm your Password"
                        value={c_password}
                        onChange={(e) => setCPassword(e.target.value)}
                        required
                      />

                      <span
                        style={{
                          position: "absolute",
                          top: "6px",
                          right: "10px",
                          cursor: "pointer",
                        }}
                        onClick={showPassword2}
                      >
                        {show2 ? (
                          <img src={VisibilityOff} width="23px" />
                        ) : (
                          <img src={Visibility} width="23px" />
                        )}
                      </span>
                    </div>
                  </div>

                  {/* <div className="field-wrap">
                    <label htmlFor="mobile">Phone Number</label>
                    <input
                      type="tel"
                      name="mobile"
                      placeholder="Enter your phone number"
                     
                    />
                  </div> */}

                  {/* <button
                    disabled={
                      name && email && password && c_password ? false : true
                    }
                    style={{backgroundColor:{name && email && password && c_password ? "#000" : "#fff" }}}
                    type="submit"
                    className="form-button"
                  >
                    Register
                  </button> */}
                  <button
                    disabled={!(name && email && password && c_password) || disabledButton }
                    style={{
                      backgroundColor:
                        name && email && password && c_password
                          ? "#000"
                          : "#e0e0e0",
                    }}
                    type="submit"
                    className="form-button"
                  >
                    Register
                  </button>
                </form>
              </div>
            </div>
          </div>

          <div className="img-container">
            <img src={dashboardImg} alt="" />
          </div>
        </div>

        <div className="footer">
          <p>2025 Real Opinion | All Rights Reserved</p>
        </div>
      </div>

      {snack && status == 404 && (
        <SnackUI
          state={snack}
          setState={setSnack}
          status={status}
          message={message}
        />
      )}
      {popup && status == 200 && (
        <Popup
          state={popup}
          setState={setPopup}
          status={status}
          btnMsg={"Ok"}
          heading={message}
          msg={
            "Your publisher account has been successfully created. Please wait for account verification. You will receive a confirmation email from Real Opinion once verified. Thank you."
          }
        />
      )}
    </>
  );
};

export default NewRegister;
